import './MktgHome.css'
import ViewCard from '../../../components/ViewCard/ViewCard'
import { ROLE_SECTIONS } from '../../../utils/sidebarURLs'

export default function MktgHome() {
   return (
      <div className='MarketingPage-grid-container'>
         {ROLE_SECTIONS.marketing.items.map(item => {
            if(item.title?.toLowerCase() === 'dashboard') return 
            return < ViewCard item={item} />
         })}
      </div>
   )
}
